import { type Html } from 'rune-ts';

export function cx(this: any, ...args: unknown[]) {
  const context: { [key: string]: string } = this && typeof this === 'object' ? this : {};

  const processClass = (cls: unknown): string[] => {
    if (typeof cls === 'string') {
      return [context[cls] || cls];
    } else if (Array.isArray(cls)) {
      return cls.flatMap(processClass);
    } else if (cls !== null && typeof cls === 'object') {
      return Object.entries(cls).flatMap(([key, value]) => (value ? [context[key] || key] : []));
    }
    return [];
  };

  return args.flatMap(processClass).filter(Boolean).join(' ');
}

// cx.bind(klass) 를 사용하는 것도 하나의 방법일 수 있습니다. (const cxb = cx.bind(klass); cxb('class1'))
export const cxList = (klass: { [x: string]: any }, classList: string[]) => {
  return classList.map((cls) => klass[cls] || '').join(' ');
};

export const cxIf = (boolean: boolean | undefined, value: string | Html) => (boolean ? value : '');
export const cxOr = (boolean: boolean | undefined, a: string | Html, b: string | Html) => (boolean ? a : b);

export const cxQs = (className: string) => `.${className}`;

export const cxId = (id?: string) => (id ? `id=${id}` : '');
export const cxCl = (className?: string) => (className ? `class=${className}` : '');

export const cxNm = (className: string) => className.split('__')[0];
